import { useMemo } from 'react';
import { useLocation } from 'react-router';

import { useResponsive } from 'hooks/useResponsive';

export const useDeviceData = () => {
  const { isMobile } = useResponsive();
  const { search } = useLocation();

  return useMemo(
    () => ({
      is_mobile: isMobile,
      query_string: search
    }),
    [isMobile, search]
  );
};
